const commonItems = {
    inicio: { icon: 'fas fa-home', text: 'Inicio', to:'/controlPanel', exact: true },
    catalogos: {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Catalogos',
        model: false,
        children: [
            { text: 'Empresas', icon: 'fas fa-building', to: '/controlPanel/empresas' },
            { text: 'Sucursales', icon: 'fas fa-building', to: '/controlPanel/sucursales' },
            { text: 'Motivos de cancelacion', icon: 'fas fa-ban', to: '/controlPanel/motivosCancelacion' },
        ],
    },
    productos: {
        text: 'Productos',
        model: false,
        children: [
            { text: 'Productos', icon: 'fas fa-th-list', to: '/controlPanel/productos' },
            { text: 'Listas de Precios', icon: 'fas fa-list-ol', to: '/controlPanel/listaPrecio' },
        ]
    },
    entradas: {
        text: 'Entradas',
        model: false,
        children: [
            // exact: Inventario apunta a la misma ruta con ?showInventory; sin esto los dos se verían activos
            { text: 'Entradas', icon: 'fas fa-cart-arrow-down', to: '/controlPanel/entradas', exact: true },
            { text: 'Proveedores', icon: 'fas fa-user-friends', to: '/controlPanel/proveedores' },
            { text: 'Pagos proveedores', icon: 'fas fa-dollar-sign', to: '/controlPanel/pagosProveedores' },
        ]
    },
    inventory: {
        text: 'Inventario',
        model: false,
        children: [
            { text: 'Inventario', icon: 'fas fa-warehouse', to: { name: 'ListaEntrada', query: { showInventory: true } }, new: true },
        ],
        update: true
    },
    ventas: {
        text: 'Ventas',
        model: true,
        children: [
            { text: 'Apertura caja', icon: 'fas fa-cash-register', to: '/controlPanel/cashRegister', new: false, update: true },
            { text: 'Ventas', icon: 'fas fa-cart-arrow-down', to: '/controlPanel/ventas', new: false, update: false },
            { text: 'Clientes', icon: 'fas fa-id-card', to: '/controlPanel/clientes' },
            { text: 'Cobranza', icon: 'fas fa-dollar-sign', to: '/controlPanel/pagos' },
        ]
    },
    transactions: {
        text: 'Ingresos/Egresos',
        model: false,
        children: [
            { text: 'Ingresos/Egresos', icon: 'fas fa-cart-arrow-down', to: '/controlPanel/transactions' },
            { text: 'Categorias', icon: 'fas fa-cash-register', to: '/controlPanel/transactionCategory' },
        ]
    },
    personal: {
        text: 'Personal',
        model: false,
        children: [
            { text: 'Empleados', icon: 'fas fa-user-tie', to: '/controlPanel/empleados' },
            { text: 'Asistencias', icon: 'fas fa-user-clock', to: '/controlPanel/asistencias' },
            { text: 'Lista de raya', icon: 'fas fa-list', to: '/controlPanel/listaRaya' },
            { text: 'Calendario',    icon: 'fas fa-calendar-alt', to: '/controlPanel/calendario' },
            { text: 'Deducciones',   icon: 'fas fa-wallet', to: '/controlPanel/deducciones' },
            { text: 'Departamentos', icon: 'fas fa-building', to: '/controlPanel/departamentos' },
            { text: 'Puestos', icon: 'fas fa-briefcase', to: '/controlPanel/puestos' },
        ]
    },
    perfil: {
        text: 'Perfil',
        model: false,
        children: [
            { text: 'Usuarios', icon: 'fas fa-user-shield', to: '/controlPanel/usuarios' },
        ]
    },
    reportes: {
        text: 'Reportes',
        model: false,
        children: [
            { text: 'Reportes', icon: 'fas fa-tasks', to: '/controlPanel/reportes' },
        ]
    },
    imports: {
        text: 'Importaciones',
        model: false,
        children: [
            { text: 'Estado de cuenta inicial', icon: 'fas fa-cogs', to: '/controlPanel/stateAccountImport' },
        ]
    },
};

const createPermissions = (roles) => {
    const permissions = {
        ROLE_ADMIN: [
            commonItems.inicio,
            commonItems.catalogos,
            commonItems.productos,
            commonItems.entradas,
            commonItems.inventory,
            commonItems.ventas,
            commonItems.transactions,
            commonItems.personal,
            commonItems.perfil,
            commonItems.reportes,
            commonItems.imports
        ],
        ROLE_VENDEDOR: [
            commonItems.inicio,
            {
                text: 'Entradas',
                model: false,
                children: [
                    commonItems.entradas.children[0],
                ]
            },
            commonItems.inventory,
            {
                text: 'Ventas',
                model: false,
                children: [
                    commonItems.ventas.children[0],
                    commonItems.ventas.children[1],
                    commonItems.ventas.children[3],
                ]
            },
            {
                text: 'Transacciones',
                model: false,
                children: [
                    commonItems.transactions.children[0]
                ]
            }
        ],
        ROLE_USER: [
            commonItems.inicio,
        ],
        ROLE_COBRANZA: [
            commonItems.inicio,            
            commonItems.ventas,
            {
                text: 'Transacciones',
                model: false,
                children: [
                    commonItems.transactions.children[0]
                ]
            }
        ],
        ROLE_ADMINISTRATOR_SUCURSAL: [
            commonItems.inicio,
            commonItems.entradas,
            commonItems.inventory,
            {
                text: 'Ventas',
                model: false,
                children: [
                    commonItems.ventas.children[0],
                    commonItems.ventas.children[1],
                    commonItems.ventas.children[2],
                    commonItems.ventas.children[3],
                ]
            },
            commonItems.transactions,
            commonItems.personal
        ],
        ROLE_ADMINISTRATOR_PRECIO: [
            commonItems.productos,
            commonItems.entradas,
            commonItems.inventory,
            {
                text: 'Ventas',
                model: false,
                children: [
                    commonItems.ventas.children[1],
                    commonItems.ventas.children[2],
                    commonItems.ventas.children[3],
                ]
            },
            commonItems.reportes,
        ],
    };

    return roles && permissions[roles] ? permissions[roles] : permissions.ROLE_USER;
};
export default createPermissions
